import { basierCirleBold } from "@/styles/fonts";
import theme from "@/styles/theme";
import SearchIcon from "@mui/icons-material/Search";
import { Box } from "@mui/material";
import SvgIcon from "@mui/material/SvgIcon";
import Typography from "@mui/material/Typography";

export default function EventNoEventsFound({ dateRange }) {
  return (
    <Box sx={noResultsStyles}>
      <SvgIcon>
        <SearchIcon />
      </SvgIcon>
      <Typography
        textAlign="center"
        variant="body1"
        className="no-results-headline"
      >
        Keine Events gefunden
      </Typography>
      <Typography textAlign="center" variant="body1" sx={{ mb: 1 }}>
        Keine Ergebnisse im Zeitraum{" "}
        <span className="date-range">
          {dateRange.startDate.toLocaleDateString()} -{" "}
          {dateRange.endDate.toLocaleDateString()}
        </span>{" "}
        gefunden.
      </Typography>
      <Typography textAlign="center" variant="body1">
        Passe deine Suche an, z. B. durch einen größeren Suchradius oder einen
        anderen Zeitraum.
      </Typography>
    </Box>
  );
}

const noResultsStyles = {
  textAlign: "center",
  padding: "2rem",
  backgroundColor: "#f4f4fe",
  "& .no-results-headline": {
    fontSize: "1.25rem",
    fontFamily: basierCirleBold.style.fontFamily,
    fontWeight: basierCirleBold.style.fontWeight,
    marginBottom: "0.5rem",
  },
  "& .date-range": {
    fontFamily: basierCirleBold.style.fontFamily,
    fontWeight: basierCirleBold.style.fontWeight,
  },
  "& .MuiTypography-root": {
    color: theme.palette.secondary.main,
    textWrap: "balance",
  },
  "& .MuiSvgIcon-root": {
    fontSize: "5rem",
    color: "#d9d8fc",
  },
};
